// const today = new Date();
// const tomorrow = new Date(today);
// tomorrow.setDate(tomorrow.getDate() + 1);
// const dateStr = tomorrow.toISOString().substring(0, 10).replace(/-/g, "");
const dateStr = new Date().toISOString().substring(0, 10).replace(/-/g, "");

const indexNameEvents = `Events`

const eventQuery = `{
  events: allWpMeshEvent(sort: {eventInformation: {timeDate: {startDate: ASC}}}) {
    edges {
      node {
        title
        id
        uri
        content
        internal {
          # querying internal.contentDigest is required
          contentDigest
        }
        featuredImage {
          node {
            altText
            sourceUrl
            localFile {
              publicURL
              extension
              childImageSharp {
                gatsbyImageData(width: 512)
              }
            }  
          }
        }  
        eventInformation {
          timeDate {
            startDate
            startTime
            endDate
            endTime
          }
          allDay
          cost
        }
        venues: meshVenues {
          nodes {
            title: name
          }
        }
      }
    }
  }
}`
const indexNamePosts = `Posts`

const postQuery = `{
  posts: allWpPost(sort: {date: DESC}) {
    edges {
      node {
        title
        uri
        internal {
          # querying internal.contentDigest is required
          contentDigest
        }
        content
        excerpt
        date(formatString: "MMMM D, YYYY")
        dateString: date
        featuredImage {
          node {
            altText
            sourceUrl
            localFile {
              publicURL
              extension
              childImageSharp {
                gatsbyImageData(width: 512)
              }
            }  
          }
        }  
        frontEndVisibility {
          frontEndVisibility
        }
      }
    }
  }
}`

function getUnixTimestamp(date) {
  if (!date) return null;
  const dateObj = new Date(date);
  const unixTimestamp = Math.floor(dateObj.getTime() / 1000);
  return unixTimestamp;
}

function eventToAlgoliaRecord({
  node: { id, title, uri, internal, eventInformation, venues, ...rest },
}) {
  const monthNames = [
    "January", "February", "March", "April", "May", "June", "July",
    "August", "September", "October", "November", "December"
  ];
  // startDate, endDate, venue
  const allDay = eventInformation?.allDay
  const startDateRaw = eventInformation?.timeDate?.startDate
  const startTime = eventInformation?.timeDate?.startTime
  const endDateRaw = eventInformation?.timeDate?.endDate
  const endTime = eventInformation?.timeDate?.endTime
  const startDate = `${startDateRaw?.substring(0, 4)}-${startDateRaw?.substring(4, 6)}-${startDateRaw?.substring(6, 8)}${allDay ? "" : ` ${startTime}`}`
  const endDate = `${endDateRaw?.substring(0, 4)}-${endDateRaw?.substring(4, 6)}-${endDateRaw?.substring(6, 8)}${allDay ? "" : ` ${endTime}`}`
  const venueNames = venues?.nodes?.length ? venues?.nodes?.map((venue) => venue?.title) : []

  function getMonthName(date) {
    const month = new Date(date).getMonth();
    return monthNames[month];
  }
  const month = []
  if (startDate) {
    month.push(getMonthName(startDate))
  }
  if (endDate) {
    month.push(getMonthName(endDate))
  }
  return {
    objectID: id || title,
    title: title,
    slug: uri,
    startDate: startDate,
    endDate: endDate,
    Venue: venueNames,
    eventInformation: eventInformation,
    Month: month,
    event_timestamp: endDate ? getUnixTimestamp(`${endDate}${allDay ? " 00:00:00" : ""}`) : startDate ? getUnixTimestamp(`${startDate}${allDay ? " 23:59:59" : ""}`) : null,
    start_timestamp: startDate ? getUnixTimestamp(`${startDate}${allDay ? " 23:59:59" : ""}`) : null,
    internal: {
      contentDigest: `${internal?.contentDigest}&date=${dateStr}`, // add version to force re-index
    },
    ...rest,
  }
}

function postToAlgoliaRecord({
  node: { id, title, uri, internal, dateString, frontEndVisibility, ...rest },
}) {
  const isPrivate = frontEndVisibility?.frontEndVisibility === "private"
  return isPrivate ? null : {
    objectID: id || title,
    title: title,
    slug: uri,
    date_timestamp: getUnixTimestamp(dateString),
    internal: {
      contentDigest: `${internal?.contentDigest}&date=${dateStr}`, // add version to force re-index
    },
    ...rest,
  }
}

const queries = [
  {
    query: eventQuery,
    transformer: ({ data }) => data.events.edges.map(eventToAlgoliaRecord),
    indexName: indexNameEvents,
  },
  {
    query: postQuery,
    transformer: ({ data }) => data.posts.edges.map(postToAlgoliaRecord).filter(Boolean),
    indexName: indexNamePosts,
  },
]

module.exports = queries
